import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { PipesModule } from '@commons/pipes/pipes.module';
import { CalculateDriveTimeRoutePipe } from '@shared/pipes/calculate-time-between-dates.pipe';
import { IRouteEventReportData } from '@src/app/interfaces/report-route.interface';
import { formatMinutesToHours } from '@src/app/utils/date';
import { Destroyable } from '@src/app/utils/Destroyable';
import { NewDataStoreService } from '@shared/services/new-data-store.service';
import { Driver } from '@commons/models/domain/Driver';

@Component({
  selector: 'app-route-part',
  standalone: true,
  imports: [CommonModule, PipesModule, CalculateDriveTimeRoutePipe, TranslateModule],
  templateUrl: './route-part.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./route-part.component.scss'],
})
export class RoutePartComponent extends Destroyable {
  @Input('data') public set data(data: IRouteEventReportData) {
    this._data = {...data};
    this.stopTime = data.stopTimeInMinutes ? formatMinutesToHours(data.stopTimeInMinutes) : 'Brak';
    data?.Dr && this.getDriverData(data.Dr);
  };

  @Input() public index: number;
  @Input() public isSelected: boolean;

  public _data: IRouteEventReportData;
  public stopTime: string;
  public driverData: Driver;

  constructor(private newDataStoreService: NewDataStoreService) {
    super();
  }

  private getDriverData(id: number): void {
    this.driverData = this.newDataStoreService.getDriverById(id);
  }

}
